import { render } from "./forced-top-element.vue?vue&type=template&id=ecc51bd4"
import script from "./forced-top-element.vue?vue&type=script&lang=js"
export * from "./forced-top-element.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git\\Odendo\\MCB-mobile\\MCB.Sites.Mobile.CustomWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__